const isInViewport = (element: Element) => {
	const rect = element.getBoundingClientRect();

	return rect.top >= 0 && rect.top < window.innerHeight;
};

export const scrollToResults = (
	scrollTargetRef: HTMLDivElement | null | undefined,
) => {
	if (scrollTargetRef == null || isInViewport(scrollTargetRef)) return;

	scrollTargetRef.scrollIntoView({ behavior: 'instant', block: 'start' });
};
